module.exports = __webpack_public_path__ + "static/media/ESN.cd6cebad.png";